import ArticleTemplate from "../../component/template/ArticleTemplate";
import Loading from "../Loading";
import "../../styles/stylesheet.scss";

export default function HelpArticle({ article, loading = false }) {
    if (loading && !article) {
        return <Loading />;
    }

    return (
        <div className="help-article-shell">
            <div className="container">
                <ArticleTemplate
                    article={article}
                    breadcrumbs={[
                        { label: "Home", href: "/" },
                        { label: "Help", href: "/help" },
                        { label: article?.title || "Article" },
                    ]}
                    backHref="/help"
                    backLabel="Back to Help Centre"
                    showSupport
                />
                {loading ? <Loading /> : null}
            </div>
        </div>
    );
}
